import React from 'react'
import { Outlet } from 'react-router-dom'

const NDOTApprovalDisapprovalOutlet = () => {
    return (
        <div className='ndot'>
            <Outlet />
        </div>
    )
}

export default NDOTApprovalDisapprovalOutlet